<template>
    <div class="xe-split-line heightMAX" @contextmenu.prevent="onContextMenu">
        <div class="split-line-inner heightMAX">
            <span v-if="widget.title" class="split-line-label" :style="labelStyle">{{ widget.title }}</span>
            <div class="split-line-rule" :style="ruleStyle"></div>
        </div>

        <!-- 설정 모달 -->
        <b-modal
            ref="modalSetting"
            :title="`${$t('설정')} - ${$t('구분선')}`"
            body-class="p-t-0 p-b-0"
            hide-footer
            @hidden="onModalCancel"
        >
            <split-line-setting
                :initSetting="splitLineSetting"
                @on-modal-cancel="onModalCancel"
                @on-modal-ok="onModalOK"
            />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import SplitLineSetting from "./setting/xeSplitLineSetting.vue";

export default {
    name: "xeSplitLine",
    extends: xeBaseWidget,
    components: {
        SplitLineSetting,
    },
    async created() {
        if (!this.widget.title) {
            this.widget.title = "";
        }
        if (!this.widget.lineColor) {
            this.widget.lineColor = "";
        }
    },
    computed: {
        splitLineSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        labelStyle() {
            return { fontSize: (this.widget.fontSize || 11) + "px" };
        },
        ruleStyle() {
            const color = this.widget.lineColor || "rgba(0,0,0,0.18)";
            return { borderTopColor: color };
        },
    },
    methods: {
        onContextMenu(e) {
            if (this.isEditMode && this.$parent && this.$parent.$refs && this.$parent.$refs.ctxMenu) {
                this.$parent.$refs.ctxMenu.open(e, this.widget);
            }
        },
        onModalCancel() {
            this.$refs.modalSetting.hide();
        },
        onModalOK(setting) {
            const updatedWidget = Object.assign({}, this.widget, setting);
            this.$refs.modalSetting.hide();
            this.$emit("on-change-widget", updatedWidget);
        },
    },
};
</script>

<style scoped>
.xe-split-line {
    display: flex;
    align-items: stretch;
    box-shadow: none !important;
}

.split-line-inner {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
    padding: 0 2px;
}

.split-line-label {
    font-size: 11px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.45);
    white-space: nowrap;
    flex-shrink: 0;
    letter-spacing: 0.03em;
}

.split-line-rule {
    flex: 1;
    border-top: 1px solid rgba(0, 0, 0, 0.18);
    min-width: 0;
}
</style>
